(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    class TextTruncator {
    constructor(wrapper) {
      this.wrapper = wrapper;
      this.percentage = parseInt(wrapper.dataset.truncatePercentage) || 50;
      this.contentSpan = wrapper.querySelector('.text-truncate-content');
      this.button = wrapper.querySelector('.text-truncate-button');
      this.readMoreText = wrapper.querySelector('.read-more-text');
      this.readLessText = wrapper.querySelector('.read-less-text');
      this.isExpanded = false;
      this.originalHTML = null;
      this.truncatedHTML = null;

      if (this.contentSpan && this.button) {
        this.init();
      }
    }

    init() {
      // Store original HTML
      this.originalHTML = this.contentSpan.innerHTML;
      
      // Truncate text based on word count percentage
      this.truncateByWordPercentage();
      this.addEventListeners();
    }

    truncateByWordPercentage() {
      // Get all text content and split into words
      const textContent = this.contentSpan.innerText || this.contentSpan.textContent;
      const words = textContent.trim().split(/\s+/);
      const totalWords = words.length;
      
      // Calculate how many words to show
      const wordCount = Math.ceil((totalWords * this.percentage) / 100);
      
      // Only truncate if we have more words than the percentage allows
      if (totalWords > wordCount) {
        // Get the HTML content and truncate at word boundary
        this.truncatedHTML = this.truncateHTMLByWords(this.originalHTML, wordCount);
        
        // Create truncated version with ellipsis
        const truncatedWithEllipsis = `<span class="truncated-text">${this.truncatedHTML}...</span>`;
        
        // Show truncated version initially
        this.contentSpan.innerHTML = truncatedWithEllipsis;
        this.contentSpan.classList.add('is-truncated');
        this.button.style.display = 'block';
      } else {
        this.contentSpan.classList.remove('is-truncated');
        this.button.style.display = 'none';
      }
    }

    truncateHTMLByWords(html, wordCount) {
      const temp = document.createElement('div');
      temp.innerHTML = html;
      
      let wordCounter = 0;
      let truncated = false;
      
      const walkNodes = (node) => {
        if (truncated) return;
        
        for (let i = 0; i < node.childNodes.length; i++) {
          const child = node.childNodes[i];
          
          if (child.nodeType === Node.TEXT_NODE) {
            const words = child.textContent.trim().split(/\s+/);
            let newText = '';
            
            for (let j = 0; j < words.length; j++) {
              if (wordCounter >= wordCount) {
                truncated = true;
                child.textContent = newText.trim();
                break;
              }
              newText += words[j] + ' ';
              wordCounter++;
            }
            
            if (!truncated) {
              child.textContent = newText.trim();
            }
          } else if (child.nodeType === Node.ELEMENT_NODE) {
            walkNodes(child);
          }
        }
      };
      
      walkNodes(temp);
      return temp.innerHTML;
    }

    addEventListeners() {
      this.button.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleExpanded();
      });
    }

    toggleExpanded() {
      this.isExpanded = !this.isExpanded;

      if (this.isExpanded) {
        // Show full content
        this.contentSpan.innerHTML = this.originalHTML;
        this.contentSpan.classList.remove('is-truncated');
        this.button.setAttribute('aria-expanded', 'true');
        this.readMoreText.style.display = 'none';
        this.readLessText.style.display = 'inline';
      } else {
        // Show truncated content
        const truncatedWithEllipsis = `<span class="truncated-text">${this.truncatedHTML}...</span>`;
        this.contentSpan.innerHTML = truncatedWithEllipsis;
        this.contentSpan.classList.add('is-truncated');
        this.button.setAttribute('aria-expanded', 'false');
        this.readMoreText.style.display = 'inline';
        this.readLessText.style.display = 'none';
      }
    }
  }

  // Initialize all text truncators
  document.querySelectorAll('.text-block-truncate-wrapper').forEach(wrapper => {
    new TextTruncator(wrapper);
  });

  // Reinitialize on Shopify theme editor updates
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:block:select', () => {
      document.querySelectorAll('.text-block-truncate-wrapper').forEach(wrapper => {
        new TextTruncator(wrapper);
      });
    });
  }
  } catch(e) { console.error(e); }
})();

})();
